import { Component } from '@angular/core';
import { Router, NavigationEnd, ActivatedRoute } from '@angular/router';
import { Title, Meta } from '@angular/platform-browser';
import { filter, map, mergeMap } from 'rxjs/operators';
import { SeoService } from './seo.service';

@Component({
  selector: 'app-root',
  templateUrl: './app.component.html',
  styleUrls: ['./app.component.scss']
})
export class AppComponent {
  route:any;
  event:any;
  title = 'ghrscf-angular';
  constructor(
    private titleService: Title,
    private meta: Meta,
    private router: Router,
    private canonical: SeoService,
    private activatedRoute: ActivatedRoute
  ) { }
  updateDescription(desc: string, keywords: string, title: string) {
    this.titleService.setTitle(title);
    // console.log(title);
    this.meta.updateTag({ name: 'description', content: desc });
    this.meta.updateTag({ name: 'keywords', content: keywords });
  }
  ngOnInit() {
    const dynamicScripts = ['../assets/js/main.js'];
    for (let i = 0; i < dynamicScripts.length; i++) {
      const node = document.createElement('script');
      node.src = dynamicScripts[i];
      node.type = 'text/javascript';
      node.async = false;
      node.charset = 'utf-8';
      document.getElementsByTagName('head')[0].appendChild(node);
      // node.onload = function () {
      //   alert('above external js library code executed');
      // }
    }
 
   this.router.events.pipe(
      filter((event) => event instanceof NavigationEnd),
      map(() => this.activatedRoute),
      map((route) => {
        while (route.firstChild) route = route.firstChild;
        return route;
      }),
      filter((route) => route.outlet === 'primary'),
      mergeMap((route) => route.data)
    )
      .subscribe((event) => {
        this.updateDescription(event['description'], event['keywords'], event['title']);
      });
    
      this.canonical.createCanonicalLink();

    }

   
}
